module.exports = __webpack_public_path__ + "static/fig1-36d6e9ec078d9930c00eb7c226efb0d6.svg";